import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap'
import { } from 'phosphor-react'
import styled from 'styled-components'

const TableHeader = styled.div`
    color: rgba(0, 0, 0, .8);
    padding-bottom: 16px;
`

const TitleWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    .title {
        color: #2D0F19;
        font-weight: 600;
    }
    .status {
        color: #2D0F19;
        font-weight: 600;
    }
    .status-0 {
        color: #D78100;
    }
    .status--1 {
        color: #FF0000;
    }
    .status-1 {
        color: #00A743;
    }
`

class TasksModal extends Component {
    render() {
        const { t, state } = this.props
        return (
            <React.Fragment>
                <ModalHeader>
                    <div className='modal-title' id="contained-modal-title-vcenter">
                        {t('study-modal-header')}
                    </div>
                </ModalHeader>
                <ModalBody>
                    <TableHeader className='lg-font-size'>{t('study-ratable-tasks')}</TableHeader>
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}>{t('study-modal-task-name')}</th>
                                <th style={{ width: '25%' }}>{t('study-modal-task-score')}</th>
                                <th style={{ width: '25%' }}>{t('study-modal-task-maxScore')}</th>
                                <th style={{ width: '25%' }}>{t('study-modal-task-status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                state.ratableTasks.map((task, index) => (
                                    <tr key={index}>
                                        <td style={{ width: '25%' }}>{task.name}</td>
                                        <td style={{ width: '25%' }}>{task.score}</td>
                                        <td style={{ width: '25%' }}>{task.maxScore}</td>
                                        <td style={{ width: '25%' }}>
                                            <TitleWrapper>
                                                <div className={`status status-${task.status} md-font-size`}>{t(`homework-status-${task.status}`)}</div>
                                            </TitleWrapper>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                        {
                            <tfoot>
                                <tr>
                                    <td>{t('study-modal-task-total-score')}</td>
                                    <td>{state.totalScore}</td>
                                    <td>{state.totalMaxScore}</td>
                                </tr>
                                <tr>
                                    <td>{t('study-modal-task-percentage')}</td>
                                    <td>{state.percent}%</td>
                                    <td>100%</td>
                                </tr>
                            </tfoot>
                        }
                    </Table>
                    {
                        <React.Fragment>
                            <TableHeader className='lg-font-size'>{t('study-unratable-tasks')}</TableHeader>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: '75%' }}>{t('study-modal-task-name')}</th>
                                        <th style={{ width: '25%' }}>{t('study-modal-task-status')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.unratableTasks.map((task, index) => (
                                            <tr key={index}>
                                                <td style={{ width: '75%' }}>{task.name}</td>
                                                <td style={{ width: '25%' }}>
                                                    <TitleWrapper>
                                                        <div className={`status status-${task.status} md-font-size`}>{t(`homework-status-${task.status}`)}</div>
                                                    </TitleWrapper>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </React.Fragment>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.props.onHide}>{t('study-modal-close')}</Button>
                </ModalFooter>
            </React.Fragment>
        )
    }
}

class EstimatesModal extends Component {
    render() {
        const { t, state } = this.props
        return (
            <React.Fragment>
                <ModalHeader>
                    <div className='modal-title' id="contained-modal-title-vcenter">
                        {t('study-modal-header')}
                    </div>
                </ModalHeader>
                <ModalBody>
                    {/* <TableHeader className='lg-font-size'>{t('study-ratable-tasks')}</TableHeader> */}
                    <Table bordered>
                        <thead>
                            <tr>
                                <th style={{ width: '33%' }}>{t('study-modal-task-name')}</th>
                                <th style={{ width: '33%' }}>{t('study-modal-task-score')}</th>
                                <th style={{ width: '33%' }}>{t('study-modal-task-maxScore')}</th>
                            </tr>

                        </thead>
                        <tbody>
                            {
                                state.map((theme, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            theme.modules.map((module, j) => (
                                                <React.Fragment key={j}>
                                                    {j < 1 ? <tr><td style={{ width: '100%' }} colSpan={3}>{theme.title}</td></tr> : ''}
                                                    <tr>
                                                        <td style={{ width: '33%' }}>{module.title}</td>
                                                        <td style={{ width: '33%' }}>{module.estimate.estimate ? module.estimate.estimate : 0}</td>
                                                        <td style={{ width: '33%' }}>{module.estimate.grade ? module.estimate.grade : 0}</td>
                                                    </tr>
                                                </React.Fragment>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                        {/* <tfoot>
                                    <tr>
                                        <td>{t('study-modal-task-total-score')}</td>
                                        <td>{state.totalScore}</td>
                                        <td>{state.totalMaxScore}</td>
                                    </tr>
                                    <tr>
                                        <td>{t('study-modal-task-percentage')}</td>
                                        <td>{state.percent}%</td>
                                        <td>100%</td>
                                    </tr>
                                </tfoot> */}
                    </Table>
                    {/* <React.Fragment>
                                <TableHeader className='lg-font-size'>{t('study-unratable-tasks')}</TableHeader>
                                <Table bordered hover>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '75%' }}>{t('study-modal-task-name')}</th>
                                            <th style={{ width: '25%' }}>{t('study-modal-task-status')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            state.unratableTasks.map((task, index) => (
                                                <tr key={index}>
                                                    <td style={{ width: '75%' }}>{task.name}</td>
                                                    <td style={{ width: '25%' }}>
                                                        <TitleWrapper>
                                                            <div className={`status status-${task.status} md-font-size`}>{t(`homework-status-${task.status}`)}</div>
                                                        </TitleWrapper>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </React.Fragment> */}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.props.onHide}>{t('study-modal-close')}</Button>
                </ModalFooter>
            </React.Fragment>
        )
    }
}

class HomeWorkModal extends Component {
    render() {
        const { t, state, onHide, estimates } = this.props
        return (
            <Modal
                isOpen={this.props.show}
                toggle={this.props.toggle}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                {
                    estimates ? <EstimatesModal t={t} state={state} onHide={onHide} />
                        : <TasksModal t={t} state={state} onHide={onHide} />
                }

            </Modal>
        )
    }
}


TasksModal.propTypes = {
    t: PropTypes.func,
    onHide: PropTypes.func,
    props: PropTypes.object,
    state: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
}

EstimatesModal.propTypes = {
    t: PropTypes.func,
    onHide: PropTypes.func,
    props: PropTypes.object,
    state: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
}

HomeWorkModal.propTypes = {
    t: PropTypes.func,
    onHide: PropTypes.func,
    show: PropTypes.bool,
    toggle: PropTypes.func,
    props: PropTypes.object,
    state: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    estimates: PropTypes.bool,
}


export default withTranslation()(HomeWorkModal)


// WEBPACK FOOTER //
// ./src/components/Study/HomeWorkModal.jsx